export const API_EXTERNAL_ENDPOINT = 'cottages/:id/price'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/cottages/price'
